import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState} from "react";
import Snackbar from '@mui/material/Snackbar';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import '../../../Modal/styleModal.css';
import { WriteConnectionComponentsFob } from '../../../WriteData/WriteConnectionComponents';

const DialogFobConnectionComponent = ({id, open, onClose, user}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [selectedComponent, setSelectedComponent] = useState('');
  const [inputId, setInputId] = useState('');
  const [inputEntrance, setInputEntrance] = useState('');

  async function connectionComponentsFobSave(event) { 
    WriteConnectionComponentsFob(id, selectedComponent, setSelectedComponent, inputId, setInputId,inputEntrance, setInputEntrance, showSnackbar, user);  
  }
  
    return (
    <Dialog open={open} className="modalStyle">
      <DialogContent>
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Закрепить фоб</label>
      <hr className='horizontalLineModal'/>
      <div>
        <select className="selectStyleModal" value={selectedComponent} onChange={(e) => setSelectedComponent(e.target.value)}>
          <option value="">Тип компонента</option>
          <option value="Pillar">Опора</option>
          <option value="Well">Колодец</option>
          <option value="House">Дом</option>
        </select>
        <br/>

        <input
          type="number"
          placeholder="Введите ID"
          className='inputDeleteModal'
          value={inputId}
          onChange={(e) => setInputId(e.target.value)}
        />
        <br/>
        {selectedComponent === "House" && (
          <input
            type="number"
            placeholder="№ подъезда"
            className='inputDeleteModal'
            value={inputEntrance}
            onChange={(e) => setInputEntrance(e.target.value)}
          />
       )}
        <br/>

        <button className='buttonIsDeleteModal'onClick={connectionComponentsFobSave}>Закрепить</button> 
        <hr className='horizontalLineModal'/>
      </div>
       {/* Snackbar */}
       <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
            }
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogFobConnectionComponent;